import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing a table view extending JetView.
 */
export default class tableView extends JetView {
    /**
     * Configures the layout of the table view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        const data = []; // Initial data array

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // Data table component
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text
                                    template: function (obj) {
                                        // Template for rendering the column
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('ID Partnert'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Nombre'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Description', // Column ID
                                    header: _('Descripción'), // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Column header
                                    options: [
                                        // Dropdown options for the column
                                        { id: 'A', value: _('Activo') },
                                        { id: 'I', value: _('Inactivo') },
                                    ],
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    // Check permissions and navigate accordingly
                                    if (devConfig.getPermAction('partnerSettingsConfiguration', 'Add')) {
                                        vthis.show(
                                            'partner.partnertManagement?partner=' + item.Id + '/partner.configuration',
                                        );
                                        return true;
                                    } else {
                                        if (devConfig.getPermAction('partnerSettingsProducts', 'Add')) {
                                            vthis.show(
                                                'partner.partnertManagement?partner=' +
                                                    item.Id +
                                                    '/partner.products/partner.products.partnersProducts',
                                            );
                                            return true;
                                        } else {
                                            if (devConfig.getPermAction('partnerSettingsProducts2', 'Add')) {
                                                vthis.show(
                                                    'partner.partnertManagement?partner=' +
                                                        item.Id +
                                                        '/partner.products2/partner.products2.partnersProducts',
                                                );
                                                return true;
                                            } else {
                                                if (devConfig.getPermAction('partnerSettingsReports', 'Add')) {
                                                    vthis.show(
                                                        'partner.partnertManagement?partner=' +
                                                            item.Id +
                                                            '/partner.reports/partner.reports.depositReport',
                                                    );
                                                    return true;
                                                } else {
                                                    if (devConfig.getPermAction('partnerSettingsTemplates', 'Add')) {
                                                        vthis.show(
                                                            'partner.partnertManagement?partner=' +
                                                                item.Id +
                                                                '/partner.templates/partner.templates.email',
                                                        );
                                                        return true;
                                                    } else {
                                                        if (devConfig.getPermAction('partnerSettingsSEO', 'Add')) {
                                                            vthis.show(
                                                                'partner.partnertManagement?partner=' +
                                                                    item.Id +
                                                                    '/partner.configurationSEO',
                                                            );
                                                            return true;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            autoConfig: false, // Disable automatic column configuration
                            pager: 'pagerA', // Pager ID
                            data: data, // Data source
                            on: {
                                // Event handlers for the datatable
                                onItemDblClick: (id) => {}, // Double-click event handler
                                onBeforeLoad: function () {
                                    // Before load event
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // After load event
                                    this.hideOverlay();
                                },
                            },
                            ready: function () {
                                // Ready event
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        var url = devConfig.geturlApi() + 'es/Partner/GetPartnerList'; // API endpoint
        var filter = ''; // Filter string
        this.on(this.app, 'partnersList:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filtering
                        if (object[i][1] !== ' ') {
                            var date = object[i][1].split(' - ');
                            console.log(date);
                            string1 = string1 + '&dateFrom=' + date[0];
                            string1 = string1 + '&dateTo=' + date[1];
                        }
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Handle object filters
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + string1, // Load new data with filters
            ).then(function (data) {
                data = data.json(); // Parse JSON response
                if (!data.HasError) {
                    // Check for errors
                    if (data.Data.length > 0) {
                        // Check if data is returned
                        this.hideOverlay();
                    } else {
                        grid.clearAll(); // Clear data if none returned
                        grid.showOverlay(
                            "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                        );
                    }
                } else {
                    grid.clearAll(); // Clear data on error
                    grid.showOverlay(
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>',
                    );
                    webix.message({
                        // Show error message
                        title: _('¡Error!'),
                        type: 'alert-error',
                        text: _('Ocurrio un error, comuniquese con soporte'),
                    });
                }
            });
            filter = string1; // Update filter string
        });
    }
}

// FILE DOCUMENTED
